import React from "react";
import { SideBar } from "./../../sidebar";
import swal from "sweetalert";
import { uploadTermsFile, getAuction } from "../../../../models/auctions";
import { AuctionTabs } from "./../../helper/auction_tabs";
import FileInput from "../../../helpers/fileInput";
import i18n from "../../../../i18n";
import HeaderBanner from "../../../common/HeaderBanner";
import "../../../../styles/components/create-group.scss";
import {
  ArrowLeft,
  Download,
  Expand,
  Eye,
  FileText,
  Loader2,
  Shrink,
} from "lucide-react";

export class AuctionTerms extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
    this.state = {
      auction: {},
      is_loading: false,
      is_loading_terms: false,
      is_loading_terms_pay: false,
      auctionId: auctionId,
      input: {},
      errors: {},
      file_terms: null,
      file_payment_terms: null,
      hideSidebar: false,
    };
    this.onFileChange = this.onFileChange.bind(this);
  }

  componentDidMount() {
    this.loadAuction();
  }

  onFileChange = (event) => {
    if (event.target.files[0].name.split(".").pop().toLowerCase() !== "pdf") {
      swal("Failed", "Wrong file format", "error");
      return;
    }
    if (event.target.name === "file_terms") {
      this.setState({ file_terms: event.target.files[0] });
      this.uploadFile(event, "T");
    }
    if (event.target.name === "file_payment_terms") {
      this.setState({ file_payment_terms: event.target.files });
      this.uploadFile(event, "P");
    }
  };

  async loadAuction() {
    this.setState({ is_loading: true });
    const response = await getAuction(this.state.auctionId);
    if (response) {
      let auction = response.data;
      this.setState({ auction });
      this.setState({ is_loading: false });
    }
  }

  async uploadFile(event, fileType) {
    event.preventDefault();
    if (!this.state.auctionId || !event.target.files[0].name) {
      swal("Failed", "File Missing", "error");
      return;
    }
    const formData = new FormData();

    if (fileType === "T") {
      this.setState({ is_loading_terms: true });
      formData.append(
        "file_terms",
        event.target.files[0],
        event.target.files[0].name
      );
    }
    if (fileType === "P") {
      this.setState({ is_loading_terms_pay: true });
      formData.append(
        "file_payment_terms",
        event.target.files[0],
        event.target.files[0].name
      );
    }

    formData.append("auction_id", this.state.auctionId);
    formData.append("type", fileType);
    const response = await uploadTermsFile(formData);
    if (response) {
      if (fileType === "P") {
        this.setState({ is_loading_terms_pay: false });
      }
      if (fileType === "T") {
        this.setState({ is_loading_terms: false });
      }
      if (response.success) {
        this.setState({ auction: response.data });
      } else {
        swal(
          "Failed",
          "Some error occured!! Please make sure that you are uploading video file.",
          "error"
        );
      }
    }
  }

  render() {
    let { auction } = this.state;
    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("terms_conditions")}
          subtitle={
            i18n.t("manage_terms_subtitle") ||
            "Upload and manage terms & conditions files"
          }
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{
                          fontSize: "1rem",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          })
                        }
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => window.history.back()}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t("back")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <AuctionTabs activeTab="terms" />
                    <div className="create-group-container">
                      {/* Loading State */}
                      {this.state.is_loading && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "3rem",
                            background: "#f9fafb",
                            borderRadius: "8px",
                          }}
                        >
                          <Loader2
                            className="animate-spin"
                            size={24}
                            style={{ marginRight: "8px" }}
                          />
                          <span>{i18n.t("loading") || "Loading..."}</span>
                        </div>
                      )}

                      {!this.state.is_loading && (
                        <div className="form-content">
                          {/* LEFT COLUMN - Terms & Conditions */}
                          <div className="left-column">
                            <div className="form-section">
                              <h2>
                                {i18n.t("upload")} {i18n.t("terms_conditions")}
                              </h2>
                              <p
                                style={{
                                  fontSize: "0.85rem",
                                  color: "#6b7280",
                                  marginBottom: "16px",
                                }}
                              >
                                {i18n.t("allowed_formats")}: .pdf only
                              </p>

                              <div className="upload-field">
                                <label>{i18n.t("terms_conditions")} *</label>

                                {/* Existing file preview */}
                                {!this.state.is_loading_terms &&
                                  auction.file_terms && (
                                    <div
                                      className="file-preview-container"
                                      style={{ marginBottom: "12px" }}
                                    >
                                      <div className="document-preview">
                                        <div className="document-icon">
                                          <FileText
                                            size={24}
                                            strokeWidth={1.5}
                                          />
                                        </div>
                                        <div className="document-info">
                                          <span className="document-name">
                                            {i18n.t("terms_conditions")}{" "}
                                            Document
                                          </span>
                                        </div>
                                        <div className="document-actions">
                                          <a
                                            href={auction.file_terms}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="preview-action-btn"
                                            title={`${i18n.t("view")}/${i18n.t("download")}`}
                                            style={{
                                              textDecoration: "none",
                                              display: "inline-flex",
                                            }}
                                          >
                                            <Eye size={16} />
                                          </a>
                                          <a
                                            href={auction.file_terms}
                                            download
                                            target="_blank"
                                            rel="noreferrer"
                                            className="preview-action-btn"
                                            title={i18n.t("download")}
                                            style={{
                                              textDecoration: "none",
                                              display: "inline-flex",
                                            }}
                                          >
                                            <Download size={16} />
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                {/* Loading */}
                                {this.state.is_loading_terms && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: "2rem",
                                      background: "#f9fafb",
                                      borderRadius: "8px",
                                      marginBottom: "12px",
                                    }}
                                  >
                                    <Loader2
                                      className="animate-spin"
                                      size={20}
                                      style={{ marginRight: "8px" }}
                                    />
                                    <span>
                                      {i18n.t("uploading") || "Uploading..."}
                                    </span>
                                  </div>
                                )}

                                {/* Upload input */}
                                <div className="upload-area">
                                  <FileInput
                                    className="form-control"
                                    placeholder={i18n.t("choose_file")}
                                    default_placeholder={i18n.t("choose_file")}
                                    id="file_terms"
                                    name="file_terms"
                                    onChange={this.onFileChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* RIGHT COLUMN - Payment Terms */}
                          <div className="right-column">
                            <div className="form-section">
                              <h2>
                                {i18n.t("upload")}{" "}
                                {i18n.t("terms_conditions_payment")}
                              </h2>
                              <p
                                style={{
                                  fontSize: "0.85rem",
                                  color: "#6b7280",
                                  marginBottom: "16px",
                                }}
                              >
                                {i18n.t("allowed_formats")}: .pdf only
                              </p>

                              <div className="upload-field">
                                <label>
                                  {i18n.t("terms_conditions_payment")} *
                                </label>

                                {/* Existing file preview */}
                                {!this.state.is_loading_terms_pay &&
                                  auction.file_payment_terms && (
                                    <div
                                      className="file-preview-container"
                                      style={{ marginBottom: "12px" }}
                                    >
                                      <div className="document-preview">
                                        <div className="document-icon">
                                          <FileText
                                            size={24}
                                            strokeWidth={1.5}
                                          />
                                        </div>
                                        <div className="document-info">
                                          <span className="document-name">
                                            {i18n.t(
                                              "terms_conditions_payment"
                                            )}{" "}
                                            Document
                                          </span>
                                        </div>
                                        <div className="document-actions">
                                          <a
                                            href={auction.file_payment_terms}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="preview-action-btn"
                                            title={`${i18n.t("view")}/${i18n.t("download")}`}
                                            style={{
                                              textDecoration: "none",
                                              display: "inline-flex",
                                            }}
                                          >
                                            <Eye size={16} />
                                          </a>
                                          <a
                                            href={auction.file_payment_terms}
                                            download
                                            target="_blank"
                                            rel="noreferrer"
                                            className="preview-action-btn"
                                            title={i18n.t("download")}
                                            style={{
                                              textDecoration: "none",
                                              display: "inline-flex",
                                            }}
                                          >
                                            <Download size={16} />
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                {/* Loading */}
                                {this.state.is_loading_terms_pay && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      padding: "2rem",
                                      background: "#f9fafb",
                                      borderRadius: "8px",
                                      marginBottom: "12px",
                                    }}
                                  >
                                    <Loader2
                                      className="animate-spin"
                                      size={20}
                                      style={{ marginRight: "8px" }}
                                    />
                                    <span>
                                      {i18n.t("uploading") || "Uploading..."}
                                    </span>
                                  </div>
                                )}

                                {/* Upload input */}
                                <div className="upload-area">
                                  <FileInput
                                    className="form-control"
                                    placeholder={i18n.t("choose_file")}
                                    default_placeholder={i18n.t("choose_file")}
                                    id="file_payment_terms"
                                    name="file_payment_terms"
                                    onChange={this.onFileChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}